export default __webpack_public_path__ + "static/media/hu.a24910ba.svg";